import { Locale } from './Locale';

export function fetchTranslations(locale: Locale) {
    return import(`../../translations/${locale}.json`);
}
